export default "__VITE_ASSET__BjXFE8nk__"